export const LIBRARY_NAME = 'msak-js', LIBRARY_VERSION = '0.3.1';
export const DEFAULT_PROTOCOL = 'wss';
export const DEFAULT_STREAMS = 2;
export const DEFAULT_CC = 'bbr';
export const DEFAULT_DURATION = 5000;

export const SUPPORTED_CC_ALGORITHMS = ['bbr', 'cubic'];

export const LOCATE_BASE_URL = 'https://locate.measurementlab.net/v2/nearest/';
export const LOCATE_RESOURCE_PATH = 'msak/throughput1';

export const DOWNLOAD_PATH = '/throughput/v1/download';
export const UPLOAD_PATH = '/throughput/v1/upload';
